import axios from 'axios';

import * as packageInfo from '../../package.json';
import * as envConfig from '../../env.json';

export const APP_VERSION = packageInfo.version;
export const SERVER_URL = envConfig.server.origin;
export const LOG_STATE_CHANGES = false;
export const AUTOSAVE_ENABLED = false;
export const APP_TITLE_PREFIX = 'RLX | ';

axios.defaults.withCredentials = true;



// WEBPACK FOOTER //
// ./client/RLX/Config.js